import React from 'react';
export default function WelcomeHeaderPart({ profile, }) {
    var _a;
    return (React.createElement("div", { className: "self-end col-span-4 desktop:ml-6" },
        React.createElement("p", { className: "flex items-center text-xs text-darkBlue/70 mb-1 uppercase" },
            React.createElement("span", { className: "icon-sun text-orange mr-2" }),
            "Sch\u00F6n, dass Du da bist!"),
        React.createElement("div", { className: "text-2xl font-bold text-darkBlue overflow-hidden break-words" }, (_a = profile === null || profile === void 0 ? void 0 : profile.nickname) !== null && _a !== void 0 ? _a : '-')));
}
